import Swiper from 'swiper';
import GLightbox from 'glightbox';
// import 'swiper/css/swiper.css'

/*
 *  Class ProductStatus
 */
export default class ProductStatus {
    constructor() {
        this.statusItems = document.querySelectorAll('.product-status:not(.preview)');
        this.swiperDisableSetup = {
            observer: true,
            observeParents: true,
            spaceBetween: 0,
            watchOverflow: true,
            resizeEvent: 'resize',
        };
        this.swiperDefaultSetup = {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            resizeEvent: 'resize',
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 40,
                },
            },
        };
    }

    initLightbox() {
        if (!document.querySelector('.product-status-item__image-link')) return;

        const groups = [];
        const links = document.querySelectorAll(
            '.product-status-item__image-link'
        );
        for (let i = 0; i < links.length; i++) {
            const group = links[i].getAttribute('group');
            if (group && groups.indexOf(group) < 0) groups.push(group);
        }

        for (let i = 0; i < groups.length; i++) {
            const lightbox = GLightbox({
                selector: `.product-status-item__image-link[group='${groups[i]}']`,
                touchNavigation: true,
                loop: true,
                autoplayVideos: true,
                type: 'image',
                onOpen: () => {
                    // console.log('Lightbox opened')
                },
            });
        }
    }

    fireResizeEvent() {
        if (typeof Event === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));
        } else {
            // for IE and other old browsers
            // causes deprecation warning on modern browsers
            var evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }
    }

    initSwiper() {
        if (!this.statusItems.length) return;
        for (let i = 0; i < this.statusItems.length; i++) {
            const statusItem = this.statusItems[i];
            const slides = statusItem.querySelectorAll('.swiper-slide');
            let swiper =
                slides.length < 2
                    ? new Swiper(statusItem, this.swiperDisableSetup)
                    : new Swiper(statusItem, this.swiperDefaultSetup);
            // swiper.update();
            swiper.updateSize();
        }
        setTimeout(this.fireResizeEvent, 200);
    }

    init() {
        this.initLightbox();
        this.initSwiper();
    }
}
